import { Component } from '@angular/core';

@Component({
  selector: 'gw-ehs-component',
  styleUrls: ['./ehs.component.scss'],
  templateUrl: './ehs.component.pug'
})
export class EhsComponent {}
